import { Dispatch } from 'redux';
import { AuthActions } from '../store/AuthSlice';

export const setAuthLoggedIn = (typeOfLogin: string, isLoggedIn: boolean) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(AuthActions.setAuthState({ typeOfLogin, isLoggedIn }));
        }
        catch (error) {
            console.log(error);
            
        }
    };
};

export default setAuthLoggedIn;